/**
 * @description: 开房套餐销售明细报表
 * @author: lyr
*/
<template>
    <div class="ktxm-report">
        <div class="red-tip">注：当天营业数据就只能单个营业日，历史数据支持一个月内的数据查询</div>
        <div class="list">
            <el-form :inline="true" :model="list_form" size="small">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="消费门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="onShopChange($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_areas_str" readonly clearable :disabled="list_form.shop_id==''" @click.native="openRoomArea"></el-input>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-select v-model="list_form.admin_id" filterable clearable placeholder="请选择操作人">
                        <el-option v-for="item in admin" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="支付类型">
                    <el-select v-model="list_form.pay_platform" filterable clearable placeholder="请选择支付类型">
                        <el-option v-for="item in pay_platform" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开房套餐类型">
                    <el-select v-model="list_form.package_type" filterable clearable placeholder="请选择开房套餐类型">
                        <el-option v-for="item in package_type" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开房套餐名称">
                    <el-input v-model="list_form.title" placeholder="请输入开房套餐名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="会员卡号">
                    <el-input v-model="list_form.vip_card" placeholder="请输入会员卡号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">销售总量：{{quantity_total}}</div>
                <div class="item">折后总额：{{actual_pay_total}}</div>
            </el-row>  
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="create_time" label="支付时间"></el-table-column>
                <el-table-column prop="order_id" label="订单编号"></el-table-column>
                <el-table-column prop="pay_platform_name" label="支付类型"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="package_type_name" label="开房套餐类型"></el-table-column>
                <el-table-column prop="title" label="开房套餐名称"></el-table-column>
                <el-table-column prop="quantity" label="销售数量"></el-table-column>
                <el-table-column prop="refund_quantity" label="退货数量"></el-table-column>
                <el-table-column prop="actual_pay" label="折后金额"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>

            <!-- 包厢区域弹窗 -->
            <div class="room-area-pop" ref="room_area_pop">
                <el-checkbox :indeterminate="allRoomAreaFlag" v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.room_areas" @change="handleCheckedRoomAreaChange">
                    <el-checkbox v-for="item in room_areas" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'ktxm-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_areas: [],
                room_areas_str: '',
                allRoomAreaFlag: false,
                checkAllRoomArea: false,
                admin: [], // 操作人
                pay_platform: [], // 支付类型
                package_type: [{
                    id: '',
                    name: '全部'
                },{
                    id: '1',
                    name: '时间套餐'
                },{
                    id: '2',
                    name: '酒水套餐'
                },{
                    id: '3',
                    name: '最低消费套餐'
                },{
                    id: '4',
                    name: '团购套餐'
                }],
                list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_areas: [],
                    pay_platform: '',
                    admin_id: '',
                    package_type: '',
                    title: '',
                    vip_card: '',
                },
                list_table: [],
                list_page: 1,
                list_total: 0,
                actual_pay_total: 0,
                quantity_total: 0,
            }
        },
        mounted: function() {
            this.list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.shop_list[0].id);
                this.getAdmin(this.shop_list[0].id)
                this.getPayType(this.shop_list[0].id)
                this.setShopDefaultTime(this.shop_list[0].id)
                this.getList(this.list_page);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.list_form.start_date = start.format('YYYY-MM-DD HH:mm');
                    _this.list_form.end_date = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 获取门店
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 改变门店
            onShopChange: function(shop_id) {
                this.list_form.room_areas = [];
                this.room_areas_str = '';
                this.allRoomAreaFlag = false
                this.checkAllRoomArea = false
                this.list_form.admin_id = ''
                this.list_form.pay_platform = ''
                if (shop_id == '') {
                    return
                }
                this.getRoomArea(shop_id);
                this.getAdmin(shop_id)
                this.getPayType(shop_id)
                this.setShopDefaultTime(shop_id)
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.room_areas = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 打开区域弹窗
            openRoomArea: function() {
                let _this = this
                let c_room_areas = _this.list_form.room_areas
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['400px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function () {
                        // 右上角关闭按钮
                        _this.list_form.room_areas = c_room_areas
                    }
                }, function() {
                    let areaTxts = []
                    if (_this.list_form.room_areas.length > 0) {
                        _this.list_form.room_areas.forEach(v => {
                            _this.room_areas.forEach(j => {
                                if (v == j.id) {
                                    areaTxts.push(j.name)
                                }
                            })
                        })
                    }
                    _this.room_areas_str = areaTxts.join(",")
                    layer.closeAll()
                }, function () {
                    _this.list_form.room_areas = c_room_areas
                    layer.closeAll()
                });
            },

            // 全选
            handleCheckAllRoomAreaChange: function (val) {
                this.list_form.room_areas = []
                if (val) {
                    this.room_areas.forEach(v => {
                        this.list_form.room_areas.push(v.id)
                    })
                }
                this.allRoomAreaFlag = false;
            },

            // 选择包厢区域
            handleCheckedRoomAreaChange: function (val) {
                let checkedCount = val.length;
                this.checkAllRoomArea = checkedCount === this.room_areas.length;
                this.allRoomAreaFlag = checkedCount > 0 && checkedCount < this.room_areas.length;
            },

            // 获取操作人
            getAdmin: function(shop_id) {
                const _this = this;

                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                       _this.admin = res.data.response.result
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        let arr = [{id: '', name: '全部'}];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            arr.push({id: key, name: value});
                        }
                       _this.pay_platform = arr
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            
            // 列表
            getList(page) {
				const _this = this;

                _this.loading = true;
				Vue.axios.post('FinanceReport2/getRoomPackageSaleList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_date,
                            "end_date": _this.list_form.end_date,
                            "shop_id": _this.list_form.shop_id,
                            "room_areas": _this.list_form.room_areas,
                            "pay_platform": _this.list_form.pay_platform,
                            "admin_id": _this.list_form.admin_id,
                            "package_type": _this.list_form.package_type,
                            "title": _this.list_form.title,
                            "vip_card": _this.list_form.vip_card,
        					}
                        },
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.data.total);
                            _this.actual_pay_total = res.data.response.result.data.actual_pay_total,
                            _this.quantity_total = res.data.response.result.data.quantity_total
                        }
						_this.list_table = res.data.response.result.data.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },
           
            listExport() {
                window.location.href = Vue.ctUrl + "FinanceReport2/exportRoomPackageSaleList?" +
                    "&start_date=" + this.list_form.start_date +
                    "&end_date=" + this.list_form.end_date +
                    "&shop_id=" + this.list_form.shop_id +
                    "&room_areas=" + this.list_form.room_areas +
                    "&pay_platform=" + this.list_form.pay_platform +
                    "&admin_id=" + this.list_form.admin_id +
                    "&package_type=" + this.list_form.package_type +
                    "&title=" + this.list_form.title +
                    "&vip_card=" + this.list_form.vip_card;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }
    .room-area-pop {
        display: none;
        .el-checkbox {
            width: 160px;
            margin: 10px auto 0;
        }
    }
</style>